import { useProtocolApiV1ListDataQuery } from "@providers/hop-ord-server/api";
import { SiteOption } from "./types";
import { useMemo } from "react";
import { ListDataCategory } from "@enums";

const sortByName = (a: string, b: string) => a.localeCompare(b);

export const useTreatingClinics = (tenantIds: number[]) => {
  const { data: treatingDepartments } = useProtocolApiV1ListDataQuery({
    categories: [ListDataCategory.TREATING_DEPARTMENT],
    tenantIds: tenantIds ?? [],
  });
  const clinicOptions = useMemo(() => {
    return (
      treatingDepartments
        ?.map((listData): SiteOption => {
          // If a value appears twice in the list, we need to show the tenant name as well.
          // Only do this for items that are duplicated at least twice.
          if (
            treatingDepartments?.filter(
              (option) => option?.value === listData?.value,
            ).length >= 2
          ) {
            const tenantName = listData?.tenantName.split(":").at(-1);
            return {
              value: listData?.value,
              label: listData?.value + " (" + tenantName + ")",
              tenantId: listData?.tenantId,
            };
          }
          return {
            value: listData?.value,
            label: listData?.value,
            tenantId: listData?.tenantId,
          };
        })
        .sort((a, b) => sortByName(a.label, b.label)) || []
    );
  }, [treatingDepartments]);

  return clinicOptions;
};
